import { render, staticRenderFns } from "./ProductCustomersAndSuppliers.vue?vue&type=template&id=365bcf04&scoped=true&lang=pug&"
import script from "./ProductCustomersAndSuppliers.vue?vue&type=script&lang=ts&"
export * from "./ProductCustomersAndSuppliers.vue?vue&type=script&lang=ts&"
import style0 from "./ProductCustomersAndSuppliers.vue?vue&type=style&index=0&id=365bcf04&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365bcf04",
  null
  
)

export default component.exports